<div id="upload-form" class="col xs12 s12 m12 l12 xl9 top-padding-16">
  <div class="form-layout">
    <form #myForm="ngForm" novalidate [formGroup]="editForm">
      <div class="upload-form">
        <div class="row text-area-resize">
          <div class="col s12 m12 l6 xl4 bold" id="notes">Comments (Optional):</div>
          <div class="col s12 m12 l6 xl8">
            <textarea class="k-textarea" kendoTextArea [autoSize]="true" maxlength="240" formControlName="notes"
              aria-label="notes" id="textArea" class="full-width"></textarea>
          </div>
        </div>
        <div class="left-margin-10 file-upload">
          <kendo-upload #myUpload class="kendo-upload" [autoUpload]="false" [saveUrl]="uploadSaveUrl" [multiple]="false"
            [removeUrl]="uploadRemoveUrl" [restrictions]="config.ExemptionFilesSupport"
            (complete)="uploadComplete(myUpload)" (upload)="uploadEventHandler($event, myForm.value)"
            (success)="uploadSuccess($event)" (select)="selectEventHandler($event)" (error)="errorEventHandler()">
            <kendo-upload-messages select="Select a file..">
            </kendo-upload-messages>
          </kendo-upload>
        </div>
      </div>
    </form>
  </div>
</div>
